import PageHeader from "@/components/PageHeader";
import Gallery from "@/sections/Gallery";
import PageCTA from "@/components/PageCTA";

const OurWorkPage = () => {
  return (
    <>
      <PageHeader
        tag="/ Our Work"
        title="OUR"
        accent="WORK."
        subtitle="A selection of recently completed commercial fit-outs and domestic before-and-after refurbishments across Edinburgh."
      />
      <Gallery />
      <PageCTA />
    </>
  );
};

export default OurWorkPage;
